import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Users, MessageSquare, Map, Calculator, Check, X, ChevronDown, ArrowRight, ShieldCheck } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function SalesOffer() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <>
      {/* WHAT YOU GET */}
      <section className="py-20 px-4 md:px-6 bg-[#fdfcfa]" data-id="element-85">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-6xl mx-auto" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1e2d4d] mb-16" data-id="element-87">
            Todo lo que necesitas para empezar
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-88">
            {[{
            icon: <BookOpen className="w-8 h-8 text-[#c9a84c]" data-id="element-89" />,
            title: 'La Guía Maestra PDF',
            desc: 'El paso a paso para pasar del trabajo físico al digital en 30 días.'
          }, {
            icon: <Users className="w-8 h-8 text-[#c9a84c]" data-id="element-90" />,
            title: 'Los 5 Roles de Oro',
            desc: 'Descripción detallada de los trabajos que puedes hacer hoy (Asistente, Moderadora, Data Entry y más).'
          }, {
            icon: <MessageSquare className="w-8 h-8 text-[#c9a84c]" data-id="element-91" />,
            title: 'Plantillas de Mensajes',
            desc: 'Qué decirle exactamente a un cliente para que te contrate (Copia y pega).'
          }, {
            icon: <Map className="w-8 h-8 text-[#c9a84c]" data-id="element-92" />,
            title: 'Mapa de Plataformas',
            desc: 'Los lugares exactos donde los latinos buscan ayuda sin pedirte inglés.'
          }, {
            icon: <Calculator className="w-8 h-8 text-[#c9a84c]" data-id="element-93" />,
            title: "Hoja de Cálculo 'Meta de Escape'",
            desc: 'Calcula cuánto necesitas ganar para dejar tu trabajo actual para siempre.'
          }].map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-94">
                <div className="bg-[#1e2d4d]/5 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-95">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-[#1e2d4d] mb-3" data-id="element-96">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-97">{item.desc}</p>
              </div>)}
          </div>
        </motion.div>
      </section>

      {/* WHO THIS IS FOR */}
      <section className="py-20 px-4 md:px-6 bg-[#2a3f65] text-white" data-id="element-98">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-5xl mx-auto" data-id="element-99">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-100">
            {/* FOR YOU */}
            <div className="bg-[#1e2d4d] p-8 rounded-2xl border border-green-500/30 shadow-lg" data-id="element-101">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3 text-green-400" data-id="element-102">
                <Check className="w-8 h-8" data-id="element-103" />
                Para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-104">
                {['Mujeres y hombres en EE.UU. cansados del trabajo físico agotador.', 'Personas que hablan español fluido pero sienten que su falta de inglés es una barrera.', 'Mamás que necesitan trabajar desde casa para estar con sus hijos.', 'Recién llegados que buscan una oportunidad digna fuera de la limpieza o construcción.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-105">
                    <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-106" />
                    <span className="text-gray-200" data-id="element-107">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* NOT FOR YOU */}
            <div className="bg-[#1e2d4d] p-8 rounded-2xl border border-red-500/30 shadow-lg" data-id="element-108">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3 text-red-400" data-id="element-109">
                <X className="w-8 h-8" data-id="element-110" />
                NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-111">
                {["Personas que buscan dinero 'mágico' sin trabajar ni aprender.", 'Quienes no tienen acceso a un teléfono inteligente o una computadora básica.', 'Quienes no están dispuestos a seguir un plan paso a paso con disciplina.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-112">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-113" />
                    <span className="text-gray-200" data-id="element-114">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 px-4 md:px-6 bg-[#fdfcfa]" data-id="element-115">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-4xl mx-auto" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1e2d4d] mb-16" data-id="element-117">
            Cómo funciona
          </h2>

          <div className="space-y-12" data-id="element-118">
            {[{
            step: '1',
            title: 'Descarga y Elige',
            desc: 'Descarga la guía y elige uno de los 5 roles digitales que mejor se adapte a ti.'
          }, {
            step: '2',
            title: 'Crea tu Perfil',
            desc: "Crea tu 'Perfil Magnético' usando nuestras plantillas de mensajes probadas."
          }, {
            step: '3',
            title: 'Consigue Clientes',
            desc: 'Contacta a tu primer cliente en el mercado hispano y asegura tu primer pago en dólares.'
          }].map((item, index) => <div key={index} className="flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left" data-id="element-119">
                <div className="w-16 h-16 rounded-full bg-[#c9a84c] text-[#1e2d4d] text-2xl font-bold flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-120">
                  {item.step}
                </div>
                <div data-id="element-121">
                  <h3 className="text-2xl font-bold text-[#1e2d4d] mb-2" data-id="element-122">
                    {item.title}
                  </h3>
                  <p className="text-lg text-gray-600" data-id="element-123">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </section>

      {/* PROOF */}
      <section className="py-20 px-4 md:px-6 bg-[#1e2d4d] text-white" data-id="element-124">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-3xl mx-auto text-center" data-id="element-125">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a84c]/20 rounded-full text-[#c9a84c] font-bold mb-8" data-id="element-126">
            <ShieldCheck className="w-5 h-5" data-id="element-127" />
            GARANTÍA DE TRANSFORMACIÓN
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-128">
            Lo que cambia en 7 días
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-129">
            En una semana, dejarás de buscar "empleos de limpieza" en Facebook y
            empezarás a enviar propuestas profesionales. Tendrás tu primer
            perfil digital activo y entenderás que tu español es una herramienta
            de ingresos que vale miles de dólares al año.
          </p>
        </motion.div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 md:px-6 bg-[#fdfcfa]" data-id="element-130">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-3xl mx-auto" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1e2d4d] mb-12" data-id="element-132">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-133">
            {[{
            q: '¿Necesito computadora o puedo usar mi celular?',
            a: 'Puedes empezar el 80% de las tareas solo con tu celular, aunque para escalar recomendamos una laptop básica.'
          }, {
            q: '¿Tengo que saber mucho de internet?',
            a: 'Si sabes usar WhatsApp y Facebook, tienes lo necesario para empezar los roles de nivel inicial.'
          }, {
            q: '¿Es legal trabajar así?',
            a: 'Sí, en esta guía te enseñamos cómo manejar tus pagos de forma transparente.'
          }, {
            q: '¿Cuánto tiempo toma ver resultados?',
            a: 'Siguiendo el plan, la mayoría de nuestros lectores consiguen sus primeras entrevistas en las primeras 2 semanas.'
          }].map((item, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-134">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-135">
                  <span className="font-bold text-[#1e2d4d] text-lg" data-id="element-136">
                    {item.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-[#c9a84c] transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-137" />
                </button>
                <AnimatePresence data-id="element-138">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-139">
                      <div className="px-6 pb-6 text-gray-600" data-id="element-140">{item.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </section>

      {/* FINAL OFFER */}
      <section id="offer" className="py-24 px-4 md:px-6 bg-[#1e2d4d] text-white text-center relative overflow-hidden" data-id="element-141">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl max-h-4xl bg-[#3a5280] opacity-30 blur-[100px] rounded-full pointer-events-none" data-id="element-142"></div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-3xl mx-auto relative z-10" data-id="element-143">
          <h2 className="text-2xl md:text-3xl font-medium mb-6 text-gray-300" data-id="element-144">
            Tu libertad física vale mucho más que una cena fuera de casa.
          </h2>

          <div className="bg-[#2a3f65] p-8 md:p-12 rounded-3xl border-2 border-[#c9a84c] shadow-2xl mb-8 transform hover:scale-[1.01] transition-transform duration-500" data-id="element-145">
            <p className="text-[#c9a84c] font-bold tracking-widest text-sm uppercase mb-4" data-id="element-146">
              OFERTA ESPECIAL
            </p>
            <h3 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-147">
              Freelance desde Cero (Sin Inglés)
            </h3>
            <p className="text-gray-400 mb-8" data-id="element-148">
              Por el precio de una pizza familiar...
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-149">
              <span className="text-gray-500 line-through text-2xl" data-id="element-150">
                $24 USD
              </span>
              <span className="text-6xl md:text-7xl font-extrabold text-[#c9a84c]" data-id="element-151">
                $6.36 <span className="text-2xl text-white" data-id="element-152">USD</span>
              </span>
            </div>

            <a href="https://coresolutionsg.com/cart/47486850629819:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'Freelance desde Cero (Sin Inglés)',
                content_type: 'product',
                value: 6.36,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto px-8 py-5 bg-[#c9a84c] hover:bg-[#f0d060] text-[#0f1b33] font-bold text-xl rounded-xl shadow-lg hover:shadow-[#c9a84c]/50 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 group animate-pulse-slow" data-id="element-153">
              ¡QUIERO EMPEZAR MI CAMBIO HOY!
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-154" />
            </a>

            <p className="mt-6 text-sm text-gray-400" data-id="element-155">
              Haz clic aquí para descargar tu guía y recibir el acceso
              inmediato.
            </p>
          </div>

          <div className="flex items-center justify-center gap-6 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-156">
            {/* Payment icons placeholder - using text for simplicity or could use lucide icons if relevant, but usually these are images */}
            <span className="text-sm" data-id="element-157">Pago 100% Seguro</span>
            <span className="text-sm" data-id="element-158">Acceso Inmediato</span>
            <span className="text-sm" data-id="element-159">Garantía de Satisfacción</span>
          </div>
        </motion.div>
      </section>
    </>;
}